import { COUNTRIES, getCountryFlag } from '../../../../consts/countries';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { map, startWith } from 'rxjs/operators';

import { BaseEditFieldComponent } from '../base-row-field/base-row-field.component';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-edit-country',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule],
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CountryEditComponent extends BaseEditFieldComponent {
  @Input() value: string;

  public countries: {value: string | null, label: string, flag: string}[] = [];
  public countryControl = new FormControl<{value: string | null, label: string, flag: string} | string>('');
  public filteredCountries: Observable<{value: string | null, label: string, flag: string}[]>;
  public showFlag: boolean = true;
  public selectedCountryFlag: string = '';

  originalOrder = () => { return 0; }

  getCountryFlag = getCountryFlag;

  ngOnInit(): void {
    super.ngOnInit();
    this.parseWidgetParams();
    this.loadCountries();
    this.setupAutocomplete();
    this.setInitialValue();
  }

  private parseWidgetParams(): void {
    if (this.widgetStructure?.widget_params) {
      try {
        const params = typeof this.widgetStructure.widget_params === 'string' 
          ? JSON.parse(this.widgetStructure.widget_params) 
          : this.widgetStructure.widget_params;
        
        if (params.show_flag !== undefined) {
          this.showFlag = params.show_flag;
        }
      } catch (e) {
        console.error('Error parsing country widget params:', e);
      }
    }
  }

  private setupAutocomplete(): void {
    this.filteredCountries = this.countryControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        // Update flag when value changes
        if (typeof value === 'object' && value !== null) {
          this.selectedCountryFlag = value.flag;
        } else if (typeof value === 'string') {
          // Clear flag if user is typing
          this.selectedCountryFlag = '';
        }
        return this._filter(typeof value === 'string' ? value : (value?.label || ''));
      })
    );
  }

  private setInitialValue(): void {
    if (this.value) {
      const country = this.countries.find(c => c.value === this.value);
      if (country) {
        this.countryControl.setValue(country);
        this.selectedCountryFlag = country.flag;
      }
    }
  }

  private _filter(value: string): {value: string | null, label: string, flag: string}[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter(country => 
      country.label?.toLowerCase().includes(filterValue) ||
      (country.value && country.value.toLowerCase().includes(filterValue))
    );
  }

  onCountrySelected(selectedCountry: {value: string | null, label: string, flag: string}): void {
    this.value = selectedCountry.value;
    this.selectedCountryFlag = selectedCountry.flag;
    this.onFieldChange.emit(this.value);
  }

  displayFn(country: any): string {
    if (!country) return '';
    // Only return the country label, flag is shown separately
    return typeof country === 'string' ? country : country.label;
  }

  private loadCountries(): void {
    this.countries = COUNTRIES.map(country => ({
      value: country.code,
      label: country.name,
      flag: getCountryFlag(country.code)
    })).toSorted((a, b) => a.label.localeCompare(b.label));

    if (this.widgetStructure?.widget_params?.allow_null || this.structure?.allow_null) {
      this.countries = [{ value: null, label: '', flag: '' }, ...this.countries];
    }
  }
}